var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticClass:"dashboard-chart",style:({ height: _vm.height, minWidth: _vm.minWidth || undefined })})
}
var staticRenderFns = []

export { render, staticRenderFns }